<!-- 文字组件 -->
<template>
  <div>
    <div
      :class="cardData.cardMode === 'dialogue' ? 'chat-card dialogue' : 'chat-card'"
      :style="`backgroundColor: ${bgColorArr[cardData.colourMode]}`"
    >
      <div>
        <div></div>
        <div v-if="cardData.plainText" class="chat-text plain-text">{{ cardData.text }}</div>
        <div v-else class="chat-text" v-html="cardData.text"></div>
          <div v-if="cardData.settings?.textChange && !hideInlineConfirm">
            <div v-if="cardData.status !== 'COMPLETED'" class="interact-area">
              <div class="user-confirm" @click="userConfirm()">
                {{ cardData.settings.textSuccess }}
              </div>
            </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="cardData.isShowTime" class="send-time">09月01日  16:29</div> -->
  </div>
</template>

<script>
export default {
  name: "ChatText",
  props: {
    cardData: {
      type: Object,
      default() {
        return {
          cardMode: "dialogue", // dialogue 对话 card 卡片
          colourMode: "default",
          isShowTime: true,
        };
      },
    },
    hideInlineConfirm: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      bgColorArr: {
        default: "#CFECFF",
        yellow: "#FAF1DF",
        purple: "#E8E3FC",
        white: "#fff",
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    userConfirm() {
      this.$set(this.cardData, "status", "COMPLETED");
      const userConfirmData = {
        id: this.cardData.id,
        text: this.cardData.settings.textSuccess,
      };
      this.$emit("sendUserConfirmMsg", userConfirmData);
    },
  },
};
</script>

<style scoped lang="scss">
.plain-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
.chat-card {
  width: 100%;
  border-radius: 12px;
  padding: 10px 12px;
  background: #cfecff;
  box-sizing: border-box;
  .chat-text {
    color: $text-color;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 23px;
  }
}
.send-time {
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 20px;
  color: #9d9fa3;
  margin-top: 4px;
}
.dialogue {
  width: 290px;
  border-radius: 12px 12px 12px 0px;
}
.interact-area {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.user-confirm {
  background-color: white;
  border-radius: 70px;
  padding: 0px 15px;
  flex-wrap: wrap;
  width: auto;
  display: inline-flex;
  color: $text-color;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 23px;
  :hover {
    cursor: pointer;
    background-color: #cfecff;
  }
}
</style>
